export default class Favorites {
    constructor() {
        this.addToFavorites = document.querySelectorAll('.js-add-to-favorites');
        this.addToFavoritesAnchors = document.querySelectorAll('.js-add-to-favorites-anchor');
        this.isFavorited = document.querySelector('.js-add-is-favorited');

        this.addToFavoritesSingle = document.querySelector('.js-single-add-to-favorites');
        this.viewFavorites = document.querySelector('.js-view-favorites');
        this.clearAllFavorites = document.querySelector('.js-clear-all-favorites');
        this.allIsFavorited = document.querySelectorAll('.is-favorited');

        this.shareEmail = document.querySelector('.js-share-favorites');


        this.favoritesFull = document.querySelector('.js-favorites-full');
        this.favoritesEmpty = document.querySelector('.js-favorites-empty');
        this.favoritesCountTitle = document.querySelector('.js-favorites-count-title');


        this.events();
    }

    events() {
        if (this.addToFavorites.length > 0) {

            this.addToFavorites.forEach((addToFavorite) => {
                addToFavorite.addEventListener('click', (event) => {
                    event.preventDefault();
                    this.updateUserMetaDataAjax(event.currentTarget, 'none');
                });

                if (addToFavorite.parentNode.parentNode) {
                    // swup disabling
                    addToFavorite.addEventListener('mouseenter', (event) => {
                        addToFavorite.parentNode.parentNode.dataset.noSwup = "";
                    });

                    // swup enabling
                    addToFavorite.addEventListener('mouseleave', (event) => {
                        delete addToFavorite.parentNode.parentNode.dataset.noSwup;
                    });
                }
            });
        }

        if (this.shareEmail) {
            this.shareEmail.setAttribute("href", "mailto:?subject=See my favourites&body=" + this.shareEmail.dataset.share);
        }

        if (this.addToFavoritesSingle) {
            this.addToFavoritesSingle.addEventListener('click', (event) => {
                event.preventDefault();

                if (event.target === this.viewFavorites) {
                    return;
                }
                this.updateUserMetaDataAjax(event.currentTarget, 'yes');
            });
        }

        if (this.viewFavorites) {
            this.viewFavorites.addEventListener('click', (event) => {
                event.preventDefault();

                window.location.href = this.viewFavorites.getAttribute("href");
            })
        }

        if (this.clearAllFavorites) {
            this.clearAllFavorites.addEventListener('click', (event) => {
                event.preventDefault();

                this.allIsFavorited.forEach((isFavorited) => {
                    isFavorited.classList.remove('is-favorited');
                });

                this.updateUserMetaDataAjax(event.currentTarget, 'all');
            })
        }
    }


    setFavoriteCookie(name, value, days) {
        let expires = "";

        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }

        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    getFavoriteCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    updateUserMetaDataAjax(currentTarget, singleProduct) {
        const apiUrl = document.querySelector('body').getAttribute('data-api-url');
        const nonce = document.querySelector('body').getAttribute('data-nonce');
        const urlMeta = 'save-user-meta';
        let xhr = new XMLHttpRequest();

        let params = "?product_id=" + currentTarget.dataset.product;

        if (singleProduct === 'none') {
            if (currentTarget.closest(".js-add-is-favorited").classList.contains("is-favorited")) {
                params += "&action=remove";
            } else {
                params += "&action=add";
            }
        } else if (singleProduct === 'yes') {
            if (currentTarget.closest(".js-single-add-to-favorites").classList.contains('is-favorited')) {
                params += "&action=remove";
            } else {
                params += "&action=add";
            }
        } else if (singleProduct === 'all') {
            params += "&action=delete";

            //console.log(params);
        }

        xhr.onload = () => {
            // Process our return data
            if (xhr.status >= 200 && xhr.status < 300) {
                // What do when the request is successful
                //console.log("success!", xhr);
                this.afterAjax(xhr.response, currentTarget, singleProduct);
            } else {
                // What do when the request fails
                // console.log("The request failed!");
                //console.log('The request failed!');
            }
        };

        xhr.open("POST", apiUrl + "/" + urlMeta + params);
        if (nonce) {
            xhr.setRequestHeader("X-WP-Nonce", nonce);
        }
        xhr.send();
    }

    afterAjax(response, currentTarget, singleProduct) {
        let data = JSON.parse(response);

        if (data.cookie) {
            this.handleCookie(data.action, currentTarget, singleProduct)
        } else {
            this.handleFavorites(data.action, currentTarget, singleProduct);
        }
    }

    handleFavorites(action, currentTarget, singleProduct) {

        if (singleProduct === 'yes') {
            if (action === 'remove') {
                currentTarget.closest(".js-single-add-to-favorites").classList.remove('is-favorited');
                this.changeFavoritesCount('remove');
            } else {
                currentTarget.closest(".js-single-add-to-favorites").classList.add('is-favorited');
                this.changeFavoritesCount('add');
            }
        } else if (singleProduct === 'none') {
            if (action === 'remove') {
                currentTarget.closest(".js-add-is-favorited").classList.remove('is-favorited');
                this.changeFavoritesCount('remove');
            } else {
                currentTarget.closest(".js-add-is-favorited").classList.add('is-favorited');
                this.changeFavoritesCount('add');
            }
        }

    }

    handleCookie(action, currentTarget, singleProduct) {
        let cookieValue = this.getFavoriteCookie('product_favorites');

        let values = [];

        if (cookieValue !== "") {
            values = cookieValue.split(',');
        }

        if (singleProduct === 'yes') {
            if (action === 'remove') {
                values.splice(values.indexOf(currentTarget.dataset.product), 1);
                currentTarget.closest(".js-single-add-to-favorites").classList.remove('is-favorited');
                this.changeFavoritesCount('remove');
            } else {
                values.push(currentTarget.dataset.product);
                currentTarget.closest(".js-single-add-to-favorites").classList.add('is-favorited');
                this.changeFavoritesCount('add');
            }
        } else if (singleProduct === 'none') {
            if (action === 'remove') {
                values.splice(values.indexOf(currentTarget.dataset.product), 1);
                currentTarget.closest(".js-add-is-favorited").classList.remove('is-favorited');
                this.changeFavoritesCount('remove');

            } else {
                values.push(currentTarget.dataset.product);
                currentTarget.closest(".js-add-is-favorited").classList.add('is-favorited');
                this.changeFavoritesCount('add');
            }
        }


        values.join(',');

        this.setFavoriteCookie('product_favorites', values, 365);
    }


    changeFavoritesCount(operation) {
        if (this.favoritesCountTitle) {
            let stringText = this.favoritesCountTitle.innerText;
            let numberString = stringText.match(/\d+/g);
            let number = 0;

            if (numberString !== null) {
                number = parseInt(numberString[0]);
            }

            if (operation === 'add') {
                number += 1;
            } else if (operation === 'remove') {
                number -= 1;
            }

            if (number) {
                this.favoritesFull.style.display = 'inline-block';
                this.favoritesEmpty.style.display = 'none';
                return this.favoritesCountTitle.innerHTML = 'Favourites (' + number + ')';
            }

            this.favoritesFull.style.display = 'none';
            this.favoritesEmpty.style.display = 'inline-block';
            return this.favoritesCountTitle.innerText = 'Favourites';

        }
    }
}
